import { Sprint } from '@marketing-milk/interfaces'
import { FullPageSidebar } from 'components/layout/FullPageLayout/Sidebar/FullPageSidebar'
import { SidebarSection } from 'components/layout/FullPageLayout/Sidebar/SidebarSection'
import { useHistory, useLocation } from 'react-router-dom'
import { getStartEndTimeText } from '../../sprint.helpers'

interface SprintsSidebarProps {
  sprints?: Sprint[]
  selectedSprintId?: number
  setSelectedSprintId: SetState<number | undefined>
}

export const SprintsSidebar = (props: SprintsSidebarProps) => {
  const history = useHistory()
  const location = useLocation()

  const handleSprintClick = (sprintId: number) => {
    props.setSelectedSprintId(sprintId)
    // Update URL with new sprintId, clear tab and campaignId
    const params = new URLSearchParams()
    params.set('sprintId', sprintId.toString())
    history.replace(`${location.pathname}?${params.toString()}`)
  }

  return (
    <FullPageSidebar>
      {props.sprints?.map(sprint => (
        <SidebarSection
          key={sprint.id}
          onClick={() => handleSprintClick(sprint.id)}
          title={sprint.name}
          className={`${
            props.selectedSprintId === sprint.id && 'bg-blue-200 border border-blue-800'
          } cursor-pointer hover:bg-gray-200`}
        >
          {getStartEndTimeText(sprint)}
        </SidebarSection>
      ))}
    </FullPageSidebar>
  )
}
